<template>
  <v-form :name="props.searchProps.formName" @keyup.enter="autoSearch = true">
    <Tabs value="0" scrollable>

      <TabList class="mb-4">
        <Tab value="0">{{ __('Basic data') }}</Tab>
      </TabList>

      <TabPanels>
        <TabPanel value="0">
          <div class="grid">
            <FormInputText fieldName="title" label="Title" size="8" :isFocus="true" v-model:field="search.title" />

            <FormMultiselect fieldName="status_id" label="Status" size="4" :options="select?.statuses"
              v-model:field="search.status_id" />
          </div>
          <div class="grid">
            <FormMultiselect fieldName="user_id" label="Assigned user" size="4" :options="select?.users"
              v-model:field="search.user_id" />

            <FormMultiselect fieldName="creator_id" label="Creator" size="4" :options="select?.users"
              v-model:field="search.creator_id" />


            <FormMultiselect fieldName="dctpriority_id" label="Priority" size="4" :options="select?.dct_priority_tasks"
              v-model:field="search.dctpriority_id" />
          </div>
        </TabPanel>
      </TabPanels>
    </Tabs>

    <div class="grid">
      <SearchButtons :searchProps="searchProps" :search="search" v-model:autoSearch="autoSearch" />
    </div>
  </v-form>
</template>

<script setup>
import { ref } from "vue";
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormInputText from '@crud/FormInputText.vue'
import FormMultiselect from '@crud/FormMultiselect.vue'
import SearchButtons from '@crud/SearchButtons.vue'
import { prepareSearch } from '@pages/Helper/crud_utils.js'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
  searchProps: Object,
})
const autoSearch = ref(false)

let search = ref({})

const options = ["statuses", "users", "dct_priority_tasks"];
const select = ref(null);

prepareSearch(search, props, options, select)

</script>

<style lang="scss" scoped></style>
